<template>
  <a-calendar>
    <ul class="events" slot="dateCellRender" slot-scope="value">
      <li :key="item.content" v-for="item in getListData(value)">
        <!-- <a-badge :status="item.type" :text="item.content" /> -->
        <span>{{item.time}}</span>
        <span>{{item.content}}</span>
      </li>
    </ul>
    <template slot="monthCellRender" slot-scope="value">
      <div class="notes-month" v-if="getMonthData(value)">
        <section>{{ getMonthData(value) }}</section>
        <span>Backlog number</span>
      </div>
    </template>
  </a-calendar>
</template>
<script>
  export default {
    methods: {
      getListData (value) {
        let listData;
        switch (value.date()) {
          case 8:
            listData = [
              { type: 'warning', content: '保养1保养', time: '09:00' },
              { type: 'warning', content: '保养2', time: '10:00' },
              { type: 'warning', content: '保养3', time: '11:00' }
            ];
            break;

          default:
        }
        return listData || [];
      },

      getMonthData (value) {
        if (value.month() === 8) {
          return 1394;
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .events {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .events .ant-badge-status {
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    font-size: 12px;
  }
  .notes-month {
    text-align: center;
    font-size: 28px;
  }
  .notes-month section {
    font-size: 28px;
  }
  ::v-deep {
    .ant-fullcalendar-column-header {
      text-align: center;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .ant-fullcalendar-date {
      height: 72px;
      border-top: none;
      margin: 0px;
      .ant-fullcalendar-content {
        height: 44px;
        ::-webkit-scrollbar {
          width: 5px;
          height: 5px;
        }
      }
      .ant-fullcalendar-value {
        text-align: left;
        font-size: 16px;
        font-weight: 700;
      }
    }
    .ant-fullcalendar table,
    .ant-fullcalendar th,
    .ant-fullcalendar td {
      border: 1px solid #ebeff5;
    }
  }
</style>